import { type ScopedProps, useListItemContext } from '../../list-item'
import * as Comp from './list-item-title.styles'

type ListItemTitleProps = {
  children: string
  testID?: string
}

export const ListItemTitle = (props: ListItemTitleProps) => {
  const { children, __scopeListItem, testID } =
    props as ScopedProps<ListItemTitleProps>
  const { disabled } = useListItemContext('ListItemTitle', __scopeListItem)
  return (
    <Comp.Title numberOfLines={2} isDisabled={disabled} testID={testID}>
      {children}
    </Comp.Title>
  )
}
